export const WHITE_SPACE_CHAR_CODE = 160;
export const WHITE_SPACE = String.fromCharCode(WHITE_SPACE_CHAR_CODE);
export const DOCUMENT_DATE_RANGE = `1990:2030`;
export const MIN_DOCUMENT_DATE = '1990-01-01T00:00:00';
export const MAX_DOCUMENT_DATE = '2030-12-31T00:00:00';
export const ONE_SECOND = 1000;
export const daysOfTheWeek = ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'];
export const SPINNER_DEFAULT_SETTINGS = {
  SPINNER_NAME: 'primary',
  SPINNER_GIF: '/assets/images/rts-loading.gif'
};
